module.exports = __webpack_public_path__ + "img/Matchmaker.bbd0cc82.jpg";